const toHHMMSS = (secs) => {
  var sec_num = parseInt(secs, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor(sec_num / 60) % 60;
  var seconds = sec_num % 60;

  return [hours, minutes, seconds]
    .map((v) => (v < 10 ? '0' + v : v))
    .filter((v, i) => v !== '00' || i > 0)
    .join(':');
};

export const createTranscriptHTMLQuote = (quoteData) => {
  let transcriptHTML = `<table style="width:100%;" cellspacing=0 cellpadding=0>
          <thead>
            <tr>
              <th style="width:20%">Speaker</th>
              <th style="width:60%">Content</th>
              <th style="width:20%">Time Stamp</th>
            </tr>
          </thead>
          <tbody>
        `;

  quoteData.transcript
    ?.filter(
      (transcriptObj) => transcriptObj.vid_file_id === quoteData.vid_file_id
    )
    .map((transcriptObj, i) => {
      transcriptHTML += `<tr id="c${i}" class="cue" data-starttime="${
        transcriptObj.start_time
      }" data-endtime="${transcriptObj.end_time}" tabindex="1">
            <td>${transcriptObj.speaker_first} ${
        transcriptObj.speaker_last
      }</td>
            <td>${transcriptObj.utterance}</td>
            <td>${toHHMMSS(transcriptObj.start_time)}-${toHHMMSS(
        transcriptObj.end_time
      )}</td>
          </tr>`;
    });
  transcriptHTML += ` </tbody>
                          </table>`;

  return transcriptHTML;
};

export function formatNumber(number) {
	let unit = '';
	let divisor = 1;

	if (number >= 1_000_000_000) {
		unit = 'b';
		divisor = 1_000_000_000;
	} else if (number >= 1_000_000) {
		unit = 'm';
		divisor = 1_000_000;
	} else if (number >= 1_000) {
		unit = 'k';
		divisor = 1_000;
	}

	const result = number / divisor;
	return `$${result.toFixed(1)}${unit}`;
}
